import { TransactionsTableV21 } from './TransactionsTableV21';

export const TransactionsV21 = () => {
  return <TransactionsTableV21 testId="detailsTransactions" />;
};
